/**
 * Service Worker Registration
 * Registers the service worker with proper error handling
 */

(function() {
  'use strict';

  // Check if service workers are supported
  if (!('serviceWorker' in navigator)) {
    console.log('Service workers not supported');
    return;
  }

  // Register service worker
  // window.addEventListener('load', async () => {
  //   try {
  //     const registration = await navigator.serviceWorker.register('/assets/service-worker.js');
  //     console.log('Service worker registered successfully:', registration.scope);
  //     // Handle updates
  //     registration.addEventListener('updatefound', () => {
  //       const newWorker = registration.installing;
  //       newWorker.addEventListener('statechange', () => {
  //         if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
  //           // New content is available, show update notification
  //           showUpdateNotification();
  //         }
  //       });
  //     });
  //     // Listen for messages from service worker
  //     navigator.serviceWorker.addEventListener('message', (event) => {
  //       console.log('Message from service worker:', event.data);
  //     });
  //   } catch (error) {
  //     console.error('Service worker registration failed:', error);
  //   }
  // });

  // Show update notification
  function showUpdateNotification() {
    // Create a simple update notification
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #333;
      color: white;
      padding: 15px 20px;
      border-radius: 8px;
      z-index: 10000;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      font-family: Arial, sans-serif;
      max-width: 300px;
    `;
    
    notification.innerHTML = `
      <div style="margin-bottom: 10px;">
        <strong>Update Available</strong>
      </div>
      <div style="margin-bottom: 15px; font-size: 14px; opacity: 0.9;">
        A new version of the site is available.
      </div>
      <button onclick="window.location.reload()" style="
        background: #007bff;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        margin-right: 10px;
      ">
        Update
      </button>
      <button onclick="this.parentElement.remove()" style="
        background: transparent;
        color: white;
        border: 1px solid rgba(255,255,255,0.3);
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
      ">
        Later
      </button>
    `;
    
    document.body.appendChild(notification);
    
    // Auto-remove after 10 seconds
    setTimeout(() => {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 10000);
  }

  // Handle online/offline status
  function updateOnlineStatus() {
    const status = navigator.onLine ? 'online' : 'offline';
    document.body.classList.toggle('offline', !navigator.onLine);
    
    // Show/hide offline indicator
    let indicator = document.getElementById('offline-indicator');
    
    if (!navigator.onLine && !indicator) {
      indicator = document.createElement('div');
      indicator.id = 'offline-indicator';
      indicator.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: #ff6b6b;
        color: white;
        text-align: center;
        padding: 10px;
        z-index: 10000;
        font-family: Arial, sans-serif;
        font-size: 14px;
      `;
      indicator.textContent = '⚡ You\'re offline. Some features may not work.';
      document.body.prepend(indicator);
    } else if (navigator.onLine && indicator) {
      indicator.remove();
    }
  }

  // Listen for online/offline events
  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
  
  // Check initial status
  updateOnlineStatus();

  // Expose service worker utilities globally
  window.serviceWorkerUtils = {
    // Force update
    async forceUpdate() {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        registration.update();
      }
    },
    
    // Check if offline
    isOffline() {
      return !navigator.onLine;
    },
    
    // Get cache status
    async getCacheStatus() {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        const stats = {};
        
        for (const name of cacheNames) {
          const cache = await caches.open(name);
          const keys = await cache.keys();
          stats[name] = keys.length;
        }
        
        return stats;
      }
      return {};
    }
  };

})(); 